var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomFrame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 981 985.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#10283a;}.cls-3{fill:#173856;}.cls-4{clip-path:url(#clip-path);}.cls-5{fill:#091c28;}.cls-6{fill:#fbbcaa;}.cls-7{fill:#20456e;}.cls-8{fill:#00a891;}.cls-9{fill:#442114;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-517 -611)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M901,1503.37v65.23c0,29.06,99,29.06,99,0v-61.93C1002.15,1462.71,903.15,1459.4,901,1503.37Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bas frame 1 m") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bas_1_m",
    "data-name": "bas 1 m"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1027,1506v70c0,26.91,67,26.91,67,0v-74Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1007,1248l-12,275c2.15-53.29-86.85-57.29-89-4l11-267Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M901,1503.37l5,65.63c0,29.06,90,29.06,90,0l4-62.33C1002.15,1462.71,903.15,1459.4,901,1503.37Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M901,1521.76c0-29.9,99-29.9,99,0l3-25.82-34-30.56-53,.83-38,13.21-3,19.82Z",
    transform: "translate(-517 -611)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1098,1252v241c0,34.27-80,34.27-80,0l-17-155,5.75-86Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M868,1166c5.12-20.85,62.12-6.85,57,14,0,0-3,38-37,32S868,1166,868,1166Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M933,1019.54c-22.58.39-40.5,9.34-49,35.46l-22,107c0,36,68,41,68,14Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M916.82,1252.5v-203s0-50,90.59-50,90.59,40,90.59,40v213Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 400,
    y: 633,
    width: 181,
    height: 9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1004,1033c-22.07-3.49-40.42-10.38-50-25.29,4.28-6.19,9.41-11.82,25-10.6l15-.11,4.51,2.79C957,1008.23,979.6,1020.56,1004,1033Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1012,1032.89c22.07-3.49,40.42-10.39,50-25.29-4.28-6.19-9.41-11.83-25-10.6l-15-.11-4.51,2.79C1059.05,1008.12,1036.4,1020.45,1012,1032.89Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1199.41,836.19c-14-20.19-23.41-3.79-23.41-5.69a169,169,0,0,0-168.59-169H1007a169,169,0,0,0-168.59,169c0,1.9-9.41-14.5-23.41,5.69-7.72,11.13-8.89,57.77,9,76.81,14.55,15.49,33,24,45.38,15A168.78,168.78,0,0,0,1007,999.49h.41A168.78,168.78,0,0,0,1145,928c12.38,9,30.83.45,45.38-15C1208.3,894,1207.13,847.32,1199.41,836.19Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1083,1016.54c22.58.39,40.5,9.34,49,35.46l22,107c0,36-68,41-68,14Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1148,1163c-5.12-20.85-62.12-6.85-57,14,0,0,3,38,37,32S1148,1163,1148,1163Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1188.84,788c-13.29-102.33-102.07-142.78-182.46-140.6C926,645.22,837.21,685.67,823.91,788,822,830,829,827,839,830c6,13,15,13,20,10,.63-11.94.33-22.08,5-41,7.45-3.34,18.27-11.35,24-19,4.29-5.52,11.11-29.76,21-32,37.8-8.57,82.42-10.92,97-10.88h.75c14.58,0,59.2,2.31,97,10.88,9.89,2.24,16.71,26.48,21,32,5.74,7.65,16.55,15.66,24,19,4.68,18.92,4.38,29.06,5,41,5,3,14,3,20-10C1183.75,827,1190.75,830,1188.84,788Z",
    transform: "translate(-517 -611)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "cadre_invisible",
    "data-name": "cadre invisible"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 981,
    height: 981
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomFrame1);
export default __webpack_public_path__ + "static/media/bottom_frame_1.9e65f449e5d3c8d1558a930d43049887.svg";
export { ForwardRef as ReactComponent };